import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  static values = {
    loadingClass: String,
    disabledClass: String,
  }

  connect() {
    if (this.element.type === 'submit') {
      // NOTE: The button is only connected to its form when it is initially rendered.
      // If the form is rendered onto the page at a different time from the button, either
      // the button should also be re-rendered or you should call the `connectToForm` method
      // on this controller manually.
      this.connectToForm()
    }
  }

  connectToForm = () => {
    setTimeout(() => {
      const formAttr = this.element.getAttribute('form')
      if (formAttr != null) {
        this.form = document.getElementById(formAttr)
      } else {
        this.form = this.element.closest('form')
      }
      this.form?.addEventListener('submit', this.onSubmit)
      addEventListener('turbo:submit-end', this.onTurboSubmitEnd)
    })
  }

  disconnect() {
    this.form?.removeEventListener('submit', this.onSubmit)
    if (this.element.type === 'submit') {
      removeEventListener('turbo:submit-end', this.onTurboSubmitEnd)
    }
  }

  onSubmit = (e) => {
    if (!e.defaultPrevented) {
      const disableWith = this.element.getAttribute('data-disable-with')
      if (disableWith) {
        this.setContent({ detail: { content: disableWith } })
      }
      this.disable()
      if (this.hasLoadingClassValue) {
        this.element.classList.add(this.loadingClassValue)
      }
    }
  }

  onTurboSubmitEnd = (e) => {
    const { srcElement } = e
    if (this.form === srcElement) {
      this.enable()
      if (this.hasLoadingClassValue) {
        this.element.classList.remove(this.loadingClassValue)
      }
    }
  }

  enable = () => {
    this.element.removeAttribute('disabled')
    if (this.hasDisabledClassValue) {
      this.element.classList.remove(this.disabledClassValue)
    }
  }

  disable = () => {
    this.element.setAttribute('disabled', true)
    if (this.hasDisabledClassValue) {
      this.element.classList.add(this.disabledClassValue)
    }
  }

  setContent = (e) => {
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = e.detail.content
    }
  }
}
